<template>
  <div class="TrainHeaderView">
    <div class="TrainHeaderView_box">
      <div class="TrainHeaderView_wrap">
        <div class="header_left" @click="toHome">
          <img class="img_item logo" :src="$imgUrl + pageConfig.logo" alt="" />
          <span class="name">{{ pageConfig.schoolName }}继续教育综合平台</span>
        </div>
        <div class="header_middle">
          <router-link
            class="router_item"
            v-for="(item, key, index) in routerConfig"
            :key="item + key + index"
            :to="item.url"
            >{{ item.text }}</router-link
          >
        </div>
        <div class="header_right_box">
          <div
            class="right_item right_1"
            :class="{ right_active: $route.name === 'myMsg' }"
            @click="$router.push({ name: 'myMsg' })"
          >
            <img src="../../../assets/images/my_msg.png" alt="" />
            <span>收件箱</span>
            <span class="drow_num" v-if="msgNum">{{ msgNum }}</span>
          </div>
          <!-- <div
            class="right_item right_1"
            :class="{ right_active: $route.query.key === 'course' }"
            @click="toNoticePage('course')"
          >
            <img src="../../../assets/images/notice.png" alt="" />
            <span>通知</span>
            <span class="un_read" v-show="+unReadNum"></span>
          </div> -->
          <div
            class="right_item right_2"
            :class="{ right_notice_active: $route.query.key === 'system' }"
            @click="toNoticePage('system')"
          >
            <img src="../../../assets/images/msg.png" alt="" />
            <span>消息通知</span>
          </div>
          <!-- 已登录 -->
          <div
            class="header_logined right_3"
            @mouseenter="showDropBox('up')"
            @mouseleave="showDropBox('down')"
          >
            <img
              class="login_ava"
              src="../../../assets/images/avatar_ico.png"
              alt=""
            />
            <span class="user_name" v-text="userName"></span>
            <i
              class="el-icon-arrow-down select_arrow"
              :class="{
                select_arrow_1: showDrop === 'up',
                select_arrow_2: showDrop === 'down',
              }"
            ></i>
            <ul class="select_drow">
              <li
                class="drow_item"
                :class="{ active_drop: currentPathName === key }"
                v-for="(item, key, index) in dropConfig"
                :key="item + key + index"
                @click="handlerPage(key)"
              >
                <span class="drow_text" v-text="item.text"></span>
              </li>
              <li class="login_out_btn" @click="toLoginOut">退出</li>
            </ul>
          </div>
          <!-- <div class="right_item right_4" @click="toLoginOut">
            <img src="../../../assets/images/loginout.png" alt="" />
            <span>退出</span>
          </div> -->
        </div>
        <div class="switch_box">
           <div
          class="tab_switch"
          v-if="pagePath !== 'loginout' && authList.length >= 2"
        >
          <div
            class="switch_item"
            :class="{ active: currentAuth === 'teach' }"
            @click="switchAuth('teach')"
            v-if="authList.includes('adultTeach') || authList.includes('studyOnline')"
          >
            成教
          </div>
          <div
            class="switch_item"
            :class="{ active: currentAuth === 'train' }"
            @click="switchAuth('train')"
            v-if="authList.includes('train')"
          >
            培训
          </div>
          <div
            class="switch_item"
            :class="{ active: currentAuth === 'selfExam' }"
            @click="switchAuth('selfExam')"
            v-if="authList.includes('selfExam')"
          >
            自考
          </div>
        </div>
        </div>

      </div>
    </div>
    <div class="TrainHeaderView_search" v-if="showSearch">
      <SearchView></SearchView>
    </div>
    <!-- <LoginoutBox v-model="showLoginBox"></LoginoutBox> -->

    <!-- 微信绑定二维码弹框 -->
    <el-dialog
      :visible.sync="showQrCodeDialog"
      width="420px"
      center
      :close-on-click-modal="false"
      custom-class="wechat-qrcode-dialog"
    >
      <div class="qrcode-dialog-content">
        <div class="wechat-header">
          <i class="el-icon-chat-dot-round wechat-icon"></i>
          <span class="wechat-title">微信扫码绑定</span>
        </div>
        <div class="qrcode-tip">请使用微信扫一扫</div>
        <div id="qrcode" ref="qrcode" class="qrcode-container"></div>
        <div class="qrcode-footer">扫描上方二维码完成绑定</div>
        <div class="btn-group">
          <div class="refresh-btn" @click="refreshQrCode">
            <i class="el-icon-refresh"></i>
            刷新二维码
          </div>
          <div class="close-btn" @click="showQrCodeDialog = false">关闭</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import to from "await-to-js";
import api from "@/fetch/api";
import SearchView from "../SearchView.vue";
import { setCookies, getCookies } from "@/utils/utils";
import { setQuery, removeCookies } from "@/utils/utils";
import QRCode from "qrcodejs2";
// import LoginoutBox from "@/components/pages/LoginoutBox"
export default {
  name: "TrainHeaderView",
  data() {
    return {
      msgNum: 0,
      showLoginBox: false,
      sysName: "继续教育综合平台",
      unReadNum: getCookies("unRead") || 0,
      onOff: getCookies("onOff") || false,
      showDrop: "",
      isBindWx: false,
      showQrCodeDialog: false,
      qrCodeInstance: null,
      checkStatusTimer: null,
      codeState: "",
      routerConfig: {
        home: {
          text: "首页",
          url: "/train/home",
        },
        forum: {
          text: "研修社区",
          url: "/train/forum",
        },
        course: {
          text: "视频课程",
          url: "/train/course",
        },
        moreLive: {
          text: "直播课程",
          url: "/train/moreLive",
        },
        homeWork: {
          text: "作业",
          url: "/train/homeWork",
        },
        // notice: {
        //   text: "消息公告",
        //   url: "/train/notice",
        // },
      },
      dropConfig: {
        account: {
          text: "账号管理",
        },
        trainClasses: {
          text: "培训班级",
        },
        myCourseForm: {
          text: "我的课表",
        },
        myGrade: {
          text: "我的成绩",
        },
        myStudy: {
          text: "学习记录",
        },
        ask: {
          text: "调查问卷",
        },
        projectNotice: {
          text: "项目通知",
        },
        cert: {
          text: "培训证书",
        },
        // buy: {
        //   text: "教材订购",
        // },
        onlineSign: {
          text: "我的签到",
        },
        myForum: {
          text: "我的帖子",
        },
        bindWx: {
          text: "绑定微信",
        },
        myFeedback: {
          text: "意见反馈",
        },
        question: {
          text: "常见问题",
        },
        contactUs: {
          text: "联系我们",
        },
      },
    };
  },
  created() {
    if (getCookies("token")) {
      this.courseNoticeUnRead();
      this.myMsgUnReadNum();
      this.getUserInfo();
    }
    setCookies("onOff", true);
  },
  mounted() {
    window.GETNOREADNUM = this.myMsgUnReadNum;
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    this.stopCheckStatus();
  },
  methods: {
    getUserInfo(){
      let _obj = JSON.parse(getCookies("userInfo"));
      this.isBindWx = _obj.haveBind == 1 ? true : false;
      if(this.isBindWx){
        this.dropConfig.bindWx.text = "解绑微信";
      }else{
        this.dropConfig.bindWx.text = "绑定微信";
      }
    },
    switchAuth(type){
      this.$store.commit("setAuth", type);
       setCookies("auth",type);
       sessionStorage.setItem('needRedirect', 'true');
        // 4. 刷新页面
        window.location.reload();
    },
    async myMsgUnReadNum() {
      const [err, res] = await to(api.myMsgUnReadNum({
        systemType: 2
      }));
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        this.msgNum = res.data;
      } else {
        console.log();
        // this.$toast.success('这是一个全局 Toast');
      }
    },
    async courseNoticeUnRead(item) {
      const [err, result] = await to(api.courseNoticeUnRead());
      if (err) return Promise.reject(err);
      if (result.code === 200) {
        this.unReadNum = result.data.unreadNum;
        setCookies("unRead", result.data.unreadNum);
      } else {
      }
    },
    setUnRead(num) {
      this.unReadNum = num;
      setCookies("unRead", num);
    },
    toNoticePage(e) {
      if (e === this.$route.query.key) {
        return;
      }
      this.$router.push({ name: "notice", query: { key: e } });
    },
    // 显示下拉
    showDropBox(e) {
      this.showDrop = e;
    },
    // 去登录页面
    toLoginOut(e) {
      this.$confirm("此操作将退出当前登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loginOutFn();
      });
    },

    // 下拉点击
    handlerPage(e) {
      if (e === "buy") {
        return this.$message.warning("此功能暂未开放");
      }
      if(e === "bindWx"){
        if(this.isBindWx){
          this.$confirm('确认是否解绑微信？解绑后将无法接收微信公众号推送的信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unBind();
        })
        }else{
          this.getBindQrCode();
        }
        return;
      }
      this.$router.push({ name: e });
    },
    async getBindQrCode(){
       const [err, res] = await to(api.getBindQrCode());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        this.codeState = res.data.state;
        this.showQrCodeDialog = true;

        // 等待 DOM 更新后生成二维码
        this.$nextTick(() => {
          this.generateQRCode(res.data.qrCodeUrl);
        });
        // 开始轮询检测绑定状态
        this.startCheckStatus();
      }
    },
    // 生成二维码
    generateQRCode(url) {
      // 清空之前的二维码
      const qrcodeContainer = this.$refs.qrcode;
      if (qrcodeContainer) {
        qrcodeContainer.innerHTML = "";
      }

      // 生成新的二维码
      this.qrCodeInstance = new QRCode(qrcodeContainer, {
        text: url,
        width: 280,
        height: 280,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    // 刷新二维码
    async refreshQrCode() {
      // 先停止之前的轮询
      this.stopCheckStatus();

      const [err, res] = await to(api.getBindQrCode());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        this.codeState = res.data.state;
        this.$message.success("二维码已刷新");

        this.$nextTick(() => {
          this.generateQRCode(res.data.qrCodeUrl);
        });
        // 重新开始轮询
        this.startCheckStatus();
      }
    },
    // 开始轮询检测绑定状态
    startCheckStatus() {
      // 先清除之前的定时器
      this.stopCheckStatus();

      // 立即执行一次检测
      this.checkStatus();

      // 每隔1秒检测一次
      this.checkStatusTimer = setInterval(() => {
        this.checkStatus();
      }, 1000);
    },
    // 停止轮询
    stopCheckStatus() {
      if (this.checkStatusTimer) {
        clearInterval(this.checkStatusTimer);
        this.checkStatusTimer = null;
      }
    },
    async unBind(){
       const [err, res] = await to(api.unBind());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        this.$message.success("解绑成功");
        this.isBindWx = false;
        this.dropConfig.bindWx.text = "绑定微信";
        this.studentGetProfile();
      }
    },
    async checkStatus(){
       const [err, res] = await to(api.checkStatus({
        state: this.codeState
       }));
      if (err) {
        return Promise.reject(err);
      }

      // 如果绑定成功
      if (res.code === 200) {
           // 停止轮询
           this.stopCheckStatus();
           // 关闭弹框
           this.showQrCodeDialog = false;
           // 显示成功提示
           this.$message.success("微信绑定成功");
           // 更新用户信息
           this.isBindWx = true;
           this.dropConfig.bindWx.text = "解绑微信";
           this.studentGetProfile();
      }
      // 如果二维码过期或失效（code 为 901 或 903），自动刷新二维码
      else if (res.code === 901 || res.code === 903) {
        console.log('二维码已过期，自动刷新...');
        // 自动刷新二维码（不显示成功提示）
        this.autoRefreshQrCode();
      }
    },
    // 自动刷新二维码（静默刷新，不显示提示）
    async autoRefreshQrCode() {
      // 先停止之前的轮询
      this.stopCheckStatus();

      const [err, res] = await to(api.getBindQrCode());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        this.codeState = res.data.state;

        this.$nextTick(() => {
          this.generateQRCode(res.data.qrCodeUrl);
        });
        // 重新开始轮询
        this.startCheckStatus();
      }
    },
    async studentGetProfile(){
      const [err, res] = await to(api.studentGetProfile());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
         setCookies("userInfo", res.data);
        this.$store.dispatch("setUserInfo",res.data);
      }
    },
    async loginOutFn() {
      const [err, res] = await to(api.userLogout());
      if (err) {
        return Promise.reject(err);
      }
      if (res.code === 200) {
        setCookies("token", "");
        setCookies("userInfo", "");
        setCookies("onOff", "");
        setCookies("homeWorkParams", "");
        this.$message.success("退出成功");
        setTimeout(() => {
          this.$router.replace({ name: "loginout" });
        }, 1000);
      }
    },
    toHome() {
      if (this.$route.name !== "home") {
        this.$router.push({ name: "home" });
      }
    },
  },
  computed: {
 currentAuth(){
    return this.$store.state.auth || 'teach';
  },
  authList(){
    return this.$store.state.userInfo.systemAuthList || [];
    // return ['adultTeach','studyOnline','train'];
  },
     pagePath(){
      return this.$route.name;
    },
    isLogin() {
      return this.$store.state.token ? true : false;
    },
    showSearch() {
      // return this.$route.name === "home" ? true : false;
      return false;
    },
    currentPathName() {
      return this.$route.meta.name || "";
    },
    userName() {
      let _name = "";
      let _obj = getCookies("userInfo");
      if (_obj) {
        _obj = JSON.parse(_obj);
        _name = _obj.name;
      }
      return _name;
    },
  },
  props: {
    pageConfig: {
      default() {
        return {};
      },
    },
  },
  watch: {
    showQrCodeDialog(newVal) {
      // 当弹框关闭时，停止轮询
      if (!newVal) {
        this.stopCheckStatus();
      }
    }
  },
  components: {
    SearchView,
    // LoginoutBox
  },
};
</script>
<style lang="scss">
@import "@/styles/color.scss";
.TrainHeaderView {
  .TrainHeaderView_box {
    height: 70px;
    background: #fff;
    color: #cdd9fc;
    // overflow: hidden;
    .TrainHeaderView_wrap {
      display: flex;
      justify-content: space-between;
      width: 1400px;
      margin: 0 auto;
      height: 70px;
      .img_item {
        width: 30px;
        height: 30px;
        object-fit: cover;
        border-radius: 10px;
        margin-right: 10px;
      }
      .header_left {
        display: flex;
        align-items: center;
        cursor: pointer;
        .logo {
          width: 30px;
          height: 30px;
        }
        .name {
          font-family: AlibabaPuHuiTi_2_85_Bold;
          font-size: 24px;
          color: #333333;
          letter-spacing: 0;
          line-height: 24px;
          font-weight: 700;
        }
      }
      .header_middle {
        height: 70px;
        line-height: 70px;
        .router_item {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #666666;
          line-height: 16px;
          font-weight: 500;
          padding: 0 8px 24px;
          border-bottom: 2px solid transparent;
          &:hover {
            color: $themeColor;
          }
        }
        .router_item + .router_item {
          margin-left: 25px;
        }
        .router-link-active {
          color: $themeColor;
          border-color: $themeColor;
        }
      }
      .header_right_box {
        display: flex;
        align-items: center;
        justify-content: center;
        .right_item {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 18px;
            height: 20px;
            margin-right: 6px;
            object-fit: contain;
          }
          span {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            line-height: 16px;
            font-weight: 500;
          }
          &:hover {
            span {
              color: $themeColor;
            }
          }
        }
        .header_logined {
          height: 56px;
          display: flex;
          align-items: center;

          color: #fff;
          cursor: pointer;
          position: relative;
          .login_ava {
            width: 19px;
            height: 19px;
            margin-right: 10px;
          }
          &:hover {
            color: #fff;
            .select_drow {
              display: flex;
            }
          }
          .user_ico {
            font-size: 24px;
            margin-right: 10px;
          }
          .user_name {
            margin-right: 10px;
            font-size: 16px;
            color: #333;
          }
          .select_arrow {
            position: absolute;
            right: 0px;
            top: 20px;
            transform: rotate(0deg);
            color: #333;
            font-size: 18px;
          }

          .select_arrow_1 {
            animation-name: arrow_ani;
            animation-duration: 0.3s;
            animation-timing-function: linear;
            animation-iteration-count: initial;
            animation-fill-mode: forwards;
            /* Safari and Chrome: */
            -webkit-animation-name: arrow_ani;
            -webkit-animation-duration: 0.3s;
            -webkit-animation-timing-function: linear;
            -webkit-animation-iteration-count: initial;
            -webkit-animation-play-state: running;
            animation-fill-mode: forwards;
          }
          @keyframes arrow_ani {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(180deg);
            }
          }

          @-webkit-keyframes arrow_ani /* Safari and Chrome */ {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(180deg);
            }
          }

          .select_arrow_2 {
            animation-name: arrow_ani_1;
            animation-duration: 0.3s;
            animation-timing-function: linear;
            animation-iteration-count: initial;
            animation-fill-mode: forwards;
            /* Safari and Chrome: */
            -webkit-animation-name: arrow_ani_1;
            -webkit-animation-duration: 0.3s;
            -webkit-animation-timing-function: linear;
            -webkit-animation-iteration-count: initial;
            -webkit-animation-play-state: running;
            animation-fill-mode: forwards;
          }
          @keyframes arrow_ani_1 {
            0% {
              transform: rotate(180deg);
            }
            100% {
              transform: rotate(0deg);
            }
          }

          @-webkit-keyframes arrow_ani_1 /* Safari and Chrome */ {
            0% {
              transform: rotate(180deg);
            }
            100% {
              transform: rotate(0deg);
            }
          }
          .select_drow {
            position: absolute;
            top: 48px;
            left: 0px;
            width: 200px;
            display: none;
            flex-wrap: wrap;
            justify-content: space-between;
            z-index: 9999 !important;
            background: #fff;
            box-shadow: 0 5px 10px 10px rgba(0, 0, 0, 0.2);
            padding: 10px;
            border-radius: 5px;
            .drow_item {
              position: relative;
              width: 88px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              color: #333;
              // background: #d6e6f8;
              border-radius: 5px;
              &:hover {
                // background: #BDDAFC;
                // color: $themeColor;
              }
            }
            .login_out_btn {
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              background: #1547ec23;
              color: $themeColor;
              margin-top: 5px;
              border-radius: 5px;
            }
            .active_drop {
              color: $themeColor;
            }
          }
        }
        .right_active {
          position: relative;
          color: $themeColor;
          &::before {
            display: block;
            content: "";
            height: 2px;
            background: $themeColor;
            width: 70px;
            position: absolute;
            bottom: -25px;
            left: 0px;
          }
        }
        .right_notice_active{
          position: relative;
          color: $themeColor;
          &::before {
            display: block;
            content: "";
            height: 2px;
            background: $themeColor;
            width: 70px;
            position: absolute;
            bottom: -25px;
            left: 14px;
          }
        }
        .right_1,
        .right_2 {
          border-right: 1px solid #d4d4d4;
          padding-right: 25px;
          margin-right: 25px;
          cursor: pointer;
        }
        .right_3 {
          padding-right: 15px;
        }
        .right_4 {
          border-left: 1px solid #d4d4d4;
          padding-left: 25px;
          cursor: pointer;
        }
        .right_2 {
          img {
            position: relative;
            top: 1px;
          }
        }
        .right_1 {
          position: relative;
          .un_read {
            position: absolute;
            left: 60px;
            top: 0;
            width: 8px;
            height: 8px;
            background: #ff3030;
            border-radius: 100%;
          }

          .drow_num {
            position: absolute;
            top: -10px;
            right: 10px;
            background: red;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 18px;
            height: 18px;
            font-size: 12px;
            border-radius: 100%;
            color: #fff !important;
          }
        }
        .header_right_tip {
          height: 28px;
          line-height: 25px;
          border: 1px solid $themeColor;
          border-radius: 10px;
          text-align: center;
          margin-left: 25px;
          font-size: 12px;
          width: 90px;
          color: $themeColor;
          cursor: pointer;
        }
      }
      .switch_box{
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .tab_switch {
        height: 30px;

        display: flex;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        .switch_item {
          height: 30px;
          line-height: 30px;
          padding: 0 10px;
          font-size: 14px;
          color: #666;
          cursor: pointer;
          border-radius: 5px;
          transition: all 0.3s ease;

          &:hover {
            color: $themeColor;
          }

          &.active {
            background: $themeColor;
            color: #fff;
          }

          &:not(:last-child) {
            margin-right: 5px;
          }
        }
      }
    }
  }
}

// 微信二维码弹框样式
.wechat-qrcode-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    background: linear-gradient(135deg, #07c160 0%, #00d97e 100%);
  }
}

.qrcode-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
  background: linear-gradient(135deg, #07c160 0%, #00d97e 100%);

  .wechat-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;

    .wechat-icon {
      font-size: 48px;
      color: #fff;
      margin-bottom: 12px;
    }

    .wechat-title {
      font-size: 22px;
      color: #fff;
      font-weight: 500;
      letter-spacing: 1px;
    }
  }

  .qrcode-tip {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.95);
    margin-bottom: 25px;
    text-align: center;
  }

  .qrcode-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    margin-bottom: 20px;

    img {
      display: block;
      border-radius: 8px;
    }
  }

  .qrcode-footer {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
    text-align: center;
    line-height: 1.6;
    margin-bottom: 20px;
  }

  .btn-group {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    width: 100%;
  }

  .refresh-btn,
  .close-btn {
    flex: 1;
    max-width: 160px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 22px;
    color: #fff;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      border-color: rgba(255, 255, 255, 0.8);
    }

    &:active {
      background: rgba(255, 255, 255, 0.15);
    }
  }

  .refresh-btn {
    i {
      margin-right: 5px;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/train/TrainHeaderView.vue